import { subscribePricePlansEvent } from "@discovery/common-dplus/lib/adobe";
import { useEffect, useGlobalState, useState, } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners, _user, } from "@discovery/common-dplus/lib/state";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { BackButton, BackButtonVariant, } from "../../components/atoms/back-button";
import { Button, ButtonVariant } from "../../components/atoms/button";
import { Icon, Icons } from "../../components/atoms/icon";
import { DplusLogo } from "../../components/atoms/DplusLogo";
import { HeaderVariants, Tags, Typography, } from "../../components/atoms/typography";
import { navigateTo } from "../../utils/common";
import Strings from "../../utils/hardcoded.json";
import { useUser } from "../../utils/hooks";
import { Background, BackgroundM, BackgroundOverLay, ButtonContainer, Container, InputWrapper, PremiumContainer, PremiumLogo, PricePlanContainer, SaveRecommendWrapper, TitleWrapper, UiWrap, UpCellMain, UpcellWrapper, RedeemVoucherWrapper, PlanPickerMobileWrapper, FloatingWrapper, DesktopView, } from "./index.styled";
import { useRef } from "react";
import { MobilePlansView } from "./plans";
const PrimaryPlan = ({ read, campaignsEnabled, descriptionM, coverImageDesktopM, coverImageMobileM, pricePlans, preferredPricePlan, buttonTitleM, }) => {
    const [userM] = useGlobalState(_user);
    const ref = useRef(null);
    const [isIntersecting, setIntersecting] = useState(true);
    const buttonTitle = M.fromMaybe(buttonTitleM, "");
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    const { isPremiumUser } = useUser();
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const [defaultPlan, setDefaultPlans] = useState(true);
    const [defaultPlanId, setDefaultPlanId] = useState("");
    const [selectedIndex, setSelectedIndex] = useState("");
    const [selectedPeriod, setSelectedPeriod] = useState("");
    const param = new URLSearchParams(window.location.search);
    const rediredtToBlf = param.get("returnUrl") || "";
    useEffect(() => {
        const refvalue = ref && ref.current;
        if (refvalue)
            observer.observe(refvalue);
        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getVoucherProduct = () => {
        const protocol = read.authService.protocol;
        const domain = read.authService.domain;
        const url = protocol + "://" + domain + `/redeem`;
        if (isAnonymous) {
            const webAuthRedirectionUrl = protocol + "://" + domain + "/login";
            navigateTo(`${webAuthRedirectionUrl}?returnUrl=${url}`);
        }
        else {
            const premiumReturnURL = window.location.origin + "/premium";
            navigateTo(`${url}?returnUrl=${premiumReturnURL}`);
        }
    };
    useEffect(() => {
        setDefaultPlan(pricePlans);
    }, [pricePlans]); //eslint-disable-line react-hooks/exhaustive-deps
    const addDecimalPoint = (price, decimalPoint) => {
        const value = price / Math.pow(10, decimalPoint);
        return value.toFixed(2);
    };
    const logBranchAdsEventForPurchase = (priceId, period) => {
        const event_and_custom_data = {
            content_id: priceId,
            name: `${"DiscoveryPlus Main" + " " + period}`,
        };
        try {
            branch &&
                branch.logEvent("PURCHASE", event_and_custom_data, function (err) {
                    console.info(err);
                });
        }
        catch (e) {
            console.info(e);
        }
    };
    const onPressContinue = () => {
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isPlanSelected = preferredPricePlanId === defaultPlanId || selectedIndex !== "";
        if (isPlanSelected) {
            const selectedId = defaultPlan ? defaultPlanId : selectedIndex;
            const selectedPriceId = defaultPlan ? defaultPlanId : selectedIndex;
            const selectedPricePeriodForAdobe = defaultPlan ? "YEAR" : selectedPeriod;
            subscribePricePlansEvent(selectedPriceId, selectedPricePeriodForAdobe, isAnonymous, userType, userId);
            logBranchAdsEventForPurchase(selectedPriceId, defaultPlan ? "ANNUAL" : selectedPeriod);
            const protocol = read.authService.protocol;
            const domain = read.authService.domain;
            const premiumReturnURL = rediredtToBlf
                ? rediredtToBlf
                : window.location.origin + "/premium";
            const url = protocol +
                "://" +
                domain +
                `/login?flow=purchase&header=premiumShow&passId=${selectedId}`;
            navigateTo(`${url}&returnUrl=${premiumReturnURL}`);
        }
    };
    const renderLabelBasedOnPeriod = (type) => {
        switch (type) {
            case "DAY":
                return "One day";
            case "INFINITE":
                return "Lifetime";
            case "MONTH":
                return "Monthly";
            case "WEEK":
                return "Weekly";
            case "YEAR":
                return "Annual";
            default:
                return;
        }
    };
    const onButtonPress = (item) => {
        setDefaultPlans(false);
        setSelectedIndex(item.id);
        setSelectedPeriod(item.period);
    };
    const setDefaultPlan = (pricePlans) => {
        pricePlans.map((item) => {
            return setDefaultPlanId(item.period === "YEAR" ? item.id : "");
        });
        return;
    };
    const PlansView = ({ item }) => {
        const price = addDecimalPoint(item.price, item.currencyDecimalPoints);
        const planLabel = renderLabelBasedOnPeriod(item.period);
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isRecommended = preferredPricePlanId === item.id;
        const isPlanActive = defaultPlan
            ? isRecommended
            : selectedIndex === item.id;
        return (React.createElement(PricePlanContainer, { onClick: () => onButtonPress(item), id: "#pricePlan" + item.period, isPlanActive: isPlanActive },
            React.createElement(UiWrap, null,
                isRecommended && (React.createElement(RenderMaybe, null, M.map((label) => (React.createElement(SaveRecommendWrapper, { isPlanActive: false },
                    React.createElement(Typography, { classNameM: M.of("recommended"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, label.toUpperCase())))), preferredPricePlan.label))),
                React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, planLabel)),
                React.createElement(PremiumContainer, null,
                    React.createElement("span", { className: isPlanActive ? "active" : "inactive" }, "\u20B9"),
                    React.createElement(Typography, { classNameM: M.of(isPlanActive ? "active" : "inactive"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, price))),
                React.createElement(RenderMaybe, null, M.map((subTitle) => (React.createElement(SaveRecommendWrapper, { isSave: true, isPlanActive: isPlanActive },
                    React.createElement(Typography, { classNameM: M.of("save"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, subTitle)))), item.secondaryTitleM)))));
    };
    const RedeemVoucher = () => {
        return (React.createElement(RedeemVoucherWrapper, null,
            React.createElement(InputWrapper, { onClick: () => getVoucherProduct() },
                React.createElement(Icon, { type: Icons.RedeemVoucher, className: "icon", color: "white" }),
                React.createElement(Typography, { classNameM: M.of("redeemTitle"), variant: HeaderVariants.headingTwo, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, Strings.APPLY)))));
    };
    const Plans = () => {
        return (React.createElement(UpcellWrapper, null,
            React.createElement(UpCellMain, null,
                React.createElement(MobilePlansView, { pricePlans: pricePlans, preferredPricePlan: preferredPricePlan, onPressContinue: onPressContinue, read: read, isDefault: true })),
            React.createElement(DesktopView, null,
                React.createElement(UpCellMain, null, pricePlans.map((item) => (React.createElement(PlansView, { item: item })))))));
    };
    const ContinueBtn = () => {
        const preferredPricePlanId = M.fromMaybe(preferredPricePlan.id, "");
        const isPlanSelected = preferredPricePlanId === defaultPlanId || selectedIndex !== "";
        return (React.createElement(DesktopView, null,
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { customstyle: "subscribe", children: buttonTitle ? buttonTitle : "Subscribe Now", variant: isPlanSelected ? ButtonVariant.Primary : ButtonVariant.Disabled, onClickM: M.of(() => onPressContinue()), id: "#subscribeButton" }))));
    };
    const PlanPicker = () => {
        return (React.createElement(PlanPickerMobileWrapper, null,
            React.createElement(MobilePlansView, { pricePlans: pricePlans, preferredPricePlan: preferredPricePlan, onPressContinue: onPressContinue, read: read })));
    };
    return isPremiumUser || isPremiumUserFromPartner ? (React.createElement(React.Fragment, null, rediredtToBlf
        ? window.location.replace(rediredtToBlf)
        : window.location.replace("/premium"))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "priceplan" },
            React.createElement(BackButton, { variant: BackButtonVariant.WithBackground },
                React.createElement(PremiumLogo, { id: "dplusLogo" },
                    React.createElement(DplusLogo, { className: "premium-image", isPremium: true, alt: "logo" }))),
            isPremiumUserFromPartner ? (React.createElement(React.Fragment, null)) : (React.createElement(Container, null,
                React.createElement(Background, { style: {
                        backgroundImage: M.foldMapConst((bg) => `url(${bg.src})`, "none", coverImageDesktopM),
                    } }),
                React.createElement(BackgroundM, { style: {
                        backgroundImage: M.foldMapConst((bg) => `url(${bg.src})`, "none", coverImageMobileM),
                    } }),
                React.createElement(BackgroundOverLay, { ref: ref },
                    React.createElement(PremiumLogo, { id: "dplusLogo" },
                        React.createElement(DplusLogo, { className: "logo", isPremium: true, alt: "logo" })),
                    React.createElement(TitleWrapper, null,
                        React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { classNameM: M.of("desc"), variant: HeaderVariants.headingTwo, tag: Tags.h2 },
                            React.createElement(React.Fragment, null, description))), descriptionM))),
                    React.createElement(Plans, null),
                    campaignsEnabled ? React.createElement(RedeemVoucher, null) : React.createElement(React.Fragment, null),
                    React.createElement(ContinueBtn, null))))),
        window.innerWidth <= 699 && !isIntersecting && (React.createElement(FloatingWrapper, null,
            React.createElement(PlanPicker, null)))));
};
export default PrimaryPlan;

